var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 81 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.5 6.667C22.057 6.667 7.168 21.555 7.168 40c0 18.444 14.89 33.333 33.334 33.333S73.834 58.444 73.834 40 58.945 6.667 40.501 6.667m14.337 21.002 4.661 4.662L33.834 58l-12.33-12.337 4.66-4.662 7.67 7.663z"
  })));
};
export default SvgCheckCircle;